import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { ActivateDreamHashTag } from "source/app/presentation/MainPanel/Dreams/HashTags/Link/Helpers/ActivateDreamHashTag";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import { GetHashTagClassNames } from "./GetHashTagStyleClassNames";
import { HandleHashTagLinkDropAsync } from "./HandleHashTagLinkDropAsync";

export function HashTagLink({
    hashTag,
}: {
    hashTag: string;
}) {
    const [classNames, setClassNames] = React.useState<string>(``);

    const dropTargetResult = useDropTarget(
        [EDragDropObject.dreamRow],
        (draggedObject: IDream) =>
            HandleHashTagLinkDropAsync(draggedObject, hashTag)
    );

    React.useEffect(() => {
        const shouldAvoidUpdate =
            dropTargetResult.draggedObject !== null &&
            !dropTargetResult.canDrop;

        if (shouldAvoidUpdate) {
            return;
        }

        const classNames = GetHashTagClassNames(dropTargetResult, hashTag);
        setClassNames(classNames);
    }, [dropTargetResult]);

    return (
        <span
            ref={dropTargetResult.dropTargetRef}
            className={containerStyleClass}
        >
            <Hyperlink
                whenClicked={() => ActivateDreamHashTag(hashTag)}
                classes={classNames}
            >
                {hashTag}
            </Hyperlink>
        </span>
    );
}

const containerStyleClass = StyleClass(`hashTagLinkContainer`, {
    margin: `5px 0px`,
});
